export default "__VITE_ASSET__Brm3Lm4L__"